import { NextPage } from 'next';
import { GetStaticProps } from 'next';
import Audioknigi from '@/components/screens/audioknigi/Audioknigi';
import { BOOKS_FOR_PAGE, API_URL, REVALIDATE_TIME } from '@/helpers/variables';
import { IBookPage } from '@/interfaces/booksPage.interface';

interface IAudioBooksRatingPage {
  books: IBookPage;
}

const AudioBooksRatingPage: NextPage<IAudioBooksRatingPage> = ({ books }) => {
  return <Audioknigi books={books} sortingName="по рейтингу" sortingUrl={'sorting/rating'} />;
};

export const getStaticProps: GetStaticProps = async () => {
  const [booksRes] = await Promise.all([fetch(`${API_URL}satellite/books?book_type=audio_book&page=1&page_size=${BOOKS_FOR_PAGE}&sort_field=rating&sort_reversed=true`)]);
  const [books] = await Promise.all([booksRes.json()]);

  return { props: { books }, revalidate: REVALIDATE_TIME };
};

export default AudioBooksRatingPage;
